module.exports = __webpack_public_path__ + "img/pick2.c316186e.png";